import { setCompleted } from "common/stepReducerCommon";
import {
  append,
  curry,
  lensPath,
  lensProp,
  over,
  pipe,
  set,
  view,
  without,
} from "ramda";

export const initialOptInsState = {
  acceptedOptIns: [],
  declinedOptIns: [],
  optInTermsDialog: {
    loading: true,
    visible: false,
    optInId: "",
  },
  optIns: [],
};

const acceptedOptInsLens = lensProp("acceptedOptIns");
const addAcceptedOptIn = curry((id, state) =>
  over(acceptedOptInsLens, append(id), state)
);
const removeAcceptedOptIn = curry((id, state) =>
  over(acceptedOptInsLens, without([id]), state)
);
export const getAcceptedOptIns = view(acceptedOptInsLens);
export const setAcceptedOptIns = set(acceptedOptInsLens);

const declinedOptInsLens = lensProp("declinedOptIns");
const addDeclinedOptIn = curry((id, state) =>
  over(declinedOptInsLens, append(id), state)
);
const removeDeclinedOptIn = curry((id, state) =>
  over(declinedOptInsLens, without([id]), state)
);
export const getDeclinedOptIns = view(declinedOptInsLens);
export const setDeclinedOptIns = set(declinedOptInsLens);

const optInsLens = lensProp("optIns");
export const setOptIns = set(optInsLens);
export const getOptIns = view(optInsLens);

const optInTermsDialogLens = lensProp("optInTermsDialog");
export const getOptInTermsDialog = view(optInTermsDialogLens);

const optInTermsDialogLoadingLens = lensPath(["optInTermsDialog", "loading"]);
export const setOptInTermsDialogLoading = set(optInTermsDialogLoadingLens);
export const getOptInTermsDialogLoading = view(optInTermsDialogLoadingLens);

const optInTermsDialogVisibleLens = lensPath(["optInTermsDialog", "visible"]);
const setOptInTermsDialogVisible = set(optInTermsDialogVisibleLens);
export const getOptInTermsDialogVisible = view(optInTermsDialogVisibleLens);

const optInTermsDialogOptInIdLens = lensPath(["optInTermsDialog", "optInId"]);
const setOptInTermsDialogOptInId = set(optInTermsDialogOptInIdLens);

export const acceptOptIn = (id, state) =>
  pipe(
    setCompleted(false),
    setOptInTermsDialogVisible(false),
    setOptInTermsDialogLoading(true),
    removeDeclinedOptIn(id),
    addAcceptedOptIn(id)
  )(state);

export const declineOptIn = (id, state) =>
  pipe(
    setCompleted(false),
    setOptInTermsDialogVisible(false),
    setOptInTermsDialogLoading(true),
    removeAcceptedOptIn(id),
    addDeclinedOptIn(id)
  )(state);

export const undoOptIn = (id, state) =>
  pipe(
    setCompleted(false),
    removeAcceptedOptIn(id),
    removeDeclinedOptIn(id)
  )(state);

export const viewOptInTerms = (id, state) =>
  pipe(setOptInTermsDialogVisible(true), setOptInTermsDialogOptInId(id))(state);
